import { AppCompComponent } from './../../app/security/app-component/app-component.component';
import { Injectable } from '@angular/core';
import { BaseService, IPaginatorService } from './base';
import { Observable } from 'rxjs';
import { AppComponent, SecurityPolicy } from '../model/security';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BasePaginator } from '../model/base/base-model';

@Injectable({
  providedIn: 'root'
})

export class AppCompService extends IPaginatorService {

  readonly baseEndpoint = 'AppComponent';

  constructor(private http: HttpClient) {
    super();
  }

  checkNameAvailibility(name: string): Observable<string[]> {
    return this.http.get<string[]>(this.baseUrl + this.baseEndpoint + '/CheckName/' + encodeURIComponent(name));
  }

  getAppCompId(): Observable<number> {
    return this.http.get<number>(this.baseUrl + this.baseEndpoint + '/GetAppCompId');
  }

  getAppCompById(Id: string): Observable<AppComponent> {
    return this.http.get<AppComponent>(this.baseUrl + this.baseEndpoint + '/GetById/' + Id);
  }

  getInternalAppComp(): Observable<any> {
    return this.http.get<any>(this.baseUrl + this.baseEndpoint + '/GetForSelectInternal');
  }

  getAppCompByAppId(Id: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + this.baseEndpoint + '/GetForSelectByAppId/' + Id);
  }

  getAppComps(): Observable<any> {
    return this.http.get<any>(this.baseUrl + this.baseEndpoint + '/GetForSelect');
  }

  getPolicyById(Id: string): Observable<SecurityPolicy> {
    return this.http.get<SecurityPolicy>(this.baseUrl + 'Policy/' + Id);
  }

  getAppCompByIds(Ids: string[]): Observable<AppComponent[]> {
    return this.http.post<AppComponent[]>(this.baseUrl + this.baseEndpoint + '/GetByIds', Ids);
  }

  getAppComp(): Observable<AppComponent[]> {
    return this.http.get<AppComponent[]>(this.baseUrl + this.baseEndpoint + '/');
  }

  GetRelatedAppComponentsByIds(appCompIds: string[]): Observable<any> {
    return this.http.post<string[]>(this.baseUrl + this.baseEndpoint + '/GetRelatedAppComponentsByIds', appCompIds);
}

  getPaginatedData<AppCompComponent>(sort: string, order: string, page: number, size: number, filter: string): Observable<BasePaginator<AppCompComponent>> {

    let url = this.baseUrl + this.baseEndpoint + '/GetPaginated/' + page + '/' + size + '?';

    if (sort && order) {
      url += `sort=${sort}&order=${order}`;
    }
    if (filter) {
      url += (sort ? '&' : '') + `filter=${filter}`;
    }

    return this.http.get<BasePaginator<AppCompComponent>>(url);
  }

  getPaginatedPostData<AppCompComponent>(params: any): Observable<BasePaginator<AppComponent>> {
    let url = this.baseUrl + this.baseEndpoint + '/GetPaginatedPost'
    return this.http.post<BasePaginator<AppComponent>>(url, params);
  }

  // getApplicationFilterChild(dependencyMapId: string[]): Observable<any[]> {
  //   return this.http.post<any[]>(this.baseUrl + 'DependencyMap/GetResourcesByDependencyMap', dependencyMapId);
  // }

  // getHistory(collectionEntryId: string): Observable<any> {
  //   return this.http.get<any>(this.baseUrl + this.baseEndpoint + '/GetAllVersions/' + collectionEntryId);
  // }

  createAppComp(appComp: AppComponent): Observable<AppComponent> {
    return this.http.post<AppComponent>(this.baseUrl + this.baseEndpoint + '', appComp);
  }

  updateAppComp(appComp: AppComponent): Observable<AppComponent> {
    return this.http.put<AppComponent>(this.baseUrl + this.baseEndpoint + '/' + appComp.Id + '?id=' + appComp.Id, appComp);
  }

  deleteAppComp(id: string): Observable<AppComponent> {
    return this.http.delete<AppComponent>(this.baseUrl + this.baseEndpoint + '/' + id);
  }

  deleteAppComps(appComp: any[]): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + this.baseEndpoint + '/DeleteAppComponents', appComp);
  }

  updateloadImage(appCompId: string, file: File) {
    const formData = new FormData();
    formData.append('AppComponentId', appCompId);
    formData.append('file', file, file.name);

    const params = new HttpParams();

    const options = {
      params,
      reportProgress: false,
    };

    return this.http.post<AppComponent>(this.baseUrl + this.baseEndpoint + '/UploadAppComponentImage', formData, options);
  }

  getLevelsInAppComponent(applicationId: string): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + this.baseEndpoint + '/CheckLevelsInAppComponent/' + applicationId);
  }

  //for sankey 
  getSankeyAppData(appId: string): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + this.baseEndpoint + '/GetForSankeyByAppId/' + appId);
  }

  CheckImpact(appCompId: string) {
    return this.http.get<any>(
        this.baseUrl + this.baseEndpoint + '/CheckImpact/' + appCompId
    );
  }
}
